<template>
  <div class="homePage01Box" :style="bg">
    <!-- 头部导航 -->
    <div class="t_bar">
      <!-- 白色logo -->
      <div class="t_placeholder">
        <!-- 白色/蓝色图标 -->
        <div class="t_icon t_icon_search01" @click="$emit('openSearch')"></div>
        <div class="t_menu pointer" @mouseenter="$emit('openMenu')">
          <div class="t_menuitem"></div>
          <div class="t_menuitem t_menuitem2"></div>
          <div class="t_menuitem"></div>
        </div>
      </div>
      <div alt="" class="t_logo t_logo02" />
      <div class="t_right">
        <div class="mN_lage pointer"></div>
        <div class="mN_lag pointer">
          <div class="text">CN</div>
        </div>
      </div>
    </div>
    <!-- <div class="videoContainer">
      <video
        class="fullscreenVideo"
        id="bgVid"
        playsinline=""
        autoplay=""
        muted=""
        loop=""
      >
        <source src="~@/assets/video/home01Video.mp4" type="video/mp4" />
      </video>
    </div> -->
    <div class="login-page">
      <!-- 此处图片用于当视屏加载失败时的替换背景图片 -->
      <!-- <div class="m_logo"></div> -->
      <div class="m_title">
        <div class="m_label">
          <div style="display: inline-block">
            <span class="m_label_inner"> 京诚所致 哲安天下</span>
            <div class="b_btn" @click="() => {
              (dialogTableVisible = true),
                $nextTick(() => {
                  $refs.videoPlayer.muted = false;
                  $refs.videoPlayer.play();
                });
            }
              " v-if="$tools.localStorageFn.get('PAGE_DATE').is_index_video">
              <img src="@/assets/images/video_white.png" alt="" />观看视频
            </div>
          </div>
        </div>
        <!-- <div class="m_content">JINGCHENGSUOZHI ZHEANTIANXIA</div> -->
      </div>
      <div class="m_tip">
        <div class="m_mouse"></div>
        <div class="m_tipDetail">鼠标下滑探索</div>
      </div>
      <img v-if="!vedioCanPlay" class="login-background" :src="$tools.localStorageFn.get('PAGE_DATE').banner" />
      <div class="videoContainer" v-else>
        <video :style="fixStyle" class="fillWidth" playsinline="" autoplay="" muted="" loop="" v-on:canplay="canplay">
          <source :src="$tools.localStorageFn.get('PAGE_DATE').banner_video" type="video/mp4" />
        </video>
      </div>
    </div>

    <el-dialog title="" @close="closeView" :visible.sync="dialogTableVisible" :modal="false">
      <video ref="videoPlayer" :src="$tools.localStorageFn.get('PAGE_DATE').index_video" class="video" width="100%"
        autoplay muted controls></video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 视频展示
      dialogTableVisible: false,
      vedioCanPlay: false, //控制视屏加载状态显示图片
      fixStyle: "", //屏幕发生变化时给播放器设置的样式

      bg: {
        background:
          this.$tools.localStorageFn.get("PAGE_DATE").banner_video
            ? ""
            : "url(" + this.$tools.localStorageFn.get("PAGE_DATE").banner +
            ") no-repeat center center",
      },
    };
  },
  mounted() {
    //判断是SAFARI时用这个
    if (!(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
      this.vedioCanPlay = true;
    } else if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
      this.vedioCanPlay = false;
    }
    this.getVideoStyle();
  },
  methods: {
    //视屏播放失败展示背景图片
    canplay() {
      this.vedioCanPlay = true;
    },
    //监听屏幕大小实时给播放器设置宽高
    getVideoStyle() {
      window.onresize = () => {
        const windowWidth = document.body.clientWidth;
        const windowHeight = document.body.clientHeight;
        const windowAspectRatio = windowHeight / windowWidth;
        if (windowWidth <= 1024) {
          this.$root.pcShow = false;
        } else {
          this.$root.pcShow = true;
        }
        let videoWidth;
        let videoHeight;
        if (windowAspectRatio < 0.5625) {
          videoWidth = windowWidth;
          videoHeight = videoWidth * 0.5625;
          this.fixStyle = {
            height: windowWidth * 0.5625 + "px",
            width: windowWidth + "px",
            "margin-bottom": (windowHeight - videoHeight) / 2 + "px",
            "margin-left": "initial",
            // width: "100%",
            // height: "100%",
          };
        } else {
          videoHeight = windowHeight;
          videoWidth = videoHeight / 0.5625;
          this.fixStyle = {
            // height: windowHeight + "px",
            // width: windowHeight / 0.5625 + "px",
            // "margin-left": (windowWidth - videoWidth) / 2 + "px",
            "margin-bottom": "initial",
            width: "100%",
            height: "100%",
          };
          this.$emit("getWindowWidth", windowWidth);
          console.log("fixStyle", this.fixStyle);
        }
      };
      window.onresize();
    },

    closeView() {
      this.$refs.videoPlayer.pause(); //暂停
    },
  },
};
</script>

<style lang="scss">
.homePage01Box {
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  position: relative;

  .t_bar {
    z-index: 200;
    position: absolute !important;
    top: 6rem;
    left: 0;
    width: 100%;
    padding: 0 8rem;
    display: flex;
    justify-content: space-between;

    .t_logo {
      width: 20.5rem;
      height: 4.5rem;
    }

    .t_logo02 {
      background: url(~@/assets/images/logo02.png) no-repeat center center;
      background-size: cover;
    }

    .t_logo03 {
      background: url(~@/assets/images/logo03.png) no-repeat center center;
      background-size: cover;
    }

    .t_placeholder {
      height: 4.5rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        // margin-left: 3.4rem;
      }

      .t_menu {
        height: 2.6rem;
        margin: 0 3.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5..7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_right {
      font-size: 2rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #ffffff;
      line-height: 4.1rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        margin-left: 3.5rem;
      }

      .t_menu {
        height: 2.6rem;
        margin-left: 4.3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5..7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_blue {
      color: #013060 !important;
    }
  }

  .videoContainer {
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -100;

    .fullscreenVideo {
      height: 100%;
      width: 100%;
    }

    video {
      object-fit: fill;
    }
  }

  .videoContainer:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    z-index: -1;
    top: 0;
    left: 0;
    background: rgba(25, 29, 34, 0.65);
  }

  .login-page {
    background-size: cover;
    background-attachment: scroll;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-wrap: wrap;

    .b_btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 1rem;
      width: 14.8rem;
      text-align: left;
      font-size: 2.2rem;
      font-family: SimHei;
      font-weight: 400;
      color: #ffffff;
      transition: 0.5s;

      img {
        margin-right: 1.6rem;
      }
    }
  }

  .login-background {
    width: 100%;
    display: block;
    position: fixed;
    top: 0;
    height: 100%;
    left: 0;
    z-index: -99;
  }

  //根据需求自行修改这个类名的样式，其他样式必须添加
  .m_logo {
    width: 20.5rem;
    height: 4.5rem;
    background: url(~@/assets/images/logo02.png) no-repeat center center;
    background-size: cover;
    position: absolute;
    top: 6rem;
  }

  .m_title {
    text-align: center;
    width: 135rem;

    .m_label {
      font-size: 8rem;
      font-family: JingZhe_XiaoWei;
      font-weight: 400;
      color: #ffffff;
      line-height: 7.7rem;
      margin-bottom: 2.3rem;
      text-align: left;
    }

    .m_content {
      font-size: 2.5rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #ffffff;
      line-height: 2.4rem;
    }
  }

  .m_tip {
    position: absolute;
    bottom: 4.6rem;
    text-align: center;

    .m_mouse {
      margin: 0 auto;
      width: 1.9rem;
      height: 2.8rem;
      background: url(~@/assets/images/icon_mouse.png) no-repeat center center;
      background-size: cover;
      margin-bottom: 1.5rem;
    }

    .m_tipDetail {
      font-size: 1.9rem;
      font-family: SimHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 1.8rem;
    }
  }

  .videoContainer {
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -100;
  }

  .videoContainer:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    z-index: -1;
    top: 0;
    left: 0;
    background: rgba(25, 29, 34, 0.65);
  }

  .fillWidth {
    width: 100%;
  }

  .m_titlt {
    position: relative;
    top: 42.2rem;
    text-align: center;
  }

  @media screen and (min-width: 1920px) {
    .t_bar {
      top: 60px;
      padding: 0 80px;

      .t_logo {
        width: 205px;
        height: 45px;
      }

      .t_placeholder {
        height: 45px;

        .t_icon {
          width: 28px;
          height: 28px;
        }

        .t_menu {
          height: 26px;
          margin: 0 35px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }

      .t_right {
        font-size: 20px;
        line-height: 41px;

        .t_icon {
          width: 28px;
          height: 28px;
          margin-left: 35px;
        }

        .t_menu {
          height: 26px;
          margin-left: 43px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }
    }

    .login-page {
      .b_btn {
        width: 148px;
        margin-left: 10px;
        font-size: 22px;

        img {
          margin-right: 16px;
        }
      }
    }

    //根据需求自行修改这个类名的样式，其他样式必须添加
    .m_logo {
      width: 205px;
      height: 45px;
      top: 60px;
    }

    .m_title {
      width: 1400px;

      .m_label {
        font-size: 80px;
        line-height: 77px;
        margin-bottom: 23px;
      }

      .m_content {
        font-size: 25px;
        line-height: 24px;
      }
    }

    .m_tip {
      bottom: 46px;

      .m_mouse {
        width: 19px;
        height: 28px;
        margin-bottom: 15px;
      }

      .m_tipDetail {
        font-size: 19px;
        line-height: 18px;
      }
    }

    .m_titlt {
      top: 422px;
    }
  }
}

.active {
  .homePage01Box {
    .m_label_inner {
      animation: focus-in-contract 2.5s ease 0s 1 normal none;
    }

    .m_content {
      animation: focus-in-contract 2.5s ease 0s 1 normal none;
    }
  }
}
</style>